'use strict';

module.exports = require('./lib/');



//////////////////
// WEBPACK FOOTER
// ../~/remarkable/index.js
// module id = 2931
// module chunks = 0